import { render, staticRenderFns } from "./DomainSelector.vue?vue&type=template&id=71a69ad0"
import script from "./DomainSelector.vue?vue&type=script&lang=js"
export * from "./DomainSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports